<template>
  <div>
    <vehicle-type-form
      :vehicleType="vehicleType"
      :submit="submit"
      :buttonText="t('create')"
      :onInput="() => {}"
      :loading="loading"
    />
  </div>
</template>

<script setup lang="ts">
import VehicleTypeForm from './Form.vue'
import Say from '@/utils/Say'
import { defineComponent, computed, ref, onBeforeMount } from 'vue';
import store from '@/store';
import { vehicleTypeStore } from '@/store/vehicleTypes'
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import sayErrorResponse from '@/mixins/sayErrorResponse'

defineComponent({
  VehicleTypeForm
})

const loading = ref(false)
const router = useRouter()
const { t } = useI18n()

const vehicleType = computed(() => {
  return vehicleTypeStore.getters.vehicleType
})

onBeforeMount(() => {
  vehicleTypeStore.commit('clearVehicleType')

  store.commit('app.setPageTitle', t('vehicleTypeCreate'))
  store.commit('app.setBreadcrumbs', [
    { text: t('vehicleType', 2), routeName: 'VehicleTypesList' },
    { text: t('vehicleTypeCreate') }
  ])
})

const submit = (imageFile: File | null) => {
  loading.value = true

  const formData = new FormData()
  formData.append('name', vehicleType.value.name || '')
  formData.append('brand', vehicleType.value.brand || '')
  formData.append('model', vehicleType.value.model || '')
  if (imageFile) {
    formData.append('image', imageFile)
  }

  vehicleTypeStore.dispatch('createVehicleType', formData).then(() => {
    loading.value = false
    Say('success', t('vehicleTypeCreateSuccess'))
    router.push({ name: 'VehicleTypesList' })
  }).catch((err) => {
    loading.value = false
    sayErrorResponse(err)
  })
}
</script>
